import { Component, input } from '@angular/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'app-callback',
  templateUrl: `./callback.component.html`,
  styleUrls: ['./callback.component.scss'],
  imports: [FaIconComponent],
})
export class CallbackComponent {
  text = input('Daten werden geladen...');
  icon = input<IconProp>(['far', 'cogs']);
  fullScreen = input(true);
}
